module.exports = __webpack_public_path__ + "static/media/Campana.8989e2b1.mp3";